// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders a quantity picker HTML select list
 *
 * NOTE: This view is shared between two different models. This leads to bad
 * code and specialized logic so we need to refactor the ComputedPrice Backbone
 * model to have an interface that is similar to the interface for the
 * ProductOptionsPricing model.
 */
M.View.ProductDetails.QuantityPicker = Backbone.View.extend({
  tagName: 'select',

  events: {
    'change': 'onChange'
  },

  initialize: function() {
    var that = this;
    // TODO: remove this.el = $(this.el); when all the references that use
    // this.el as this.$el are fixed.
    this.$el = this.el = $(this.el);
    this.model.bind('priceUpdated', function() {
      that.render();
    });
    this.model.bind('change', function() {
      that.render();
    });
  },

  /**
   * Return true if at least one price in the price list will be represented as
   * a decimal.
   * quantities - a list of (quantity, price) tuples.
   */
  priceListContainsDecimals: function(quantities) {
    for (var i = 0, len = quantities.length; i < len; i++) {
      var price = quantities[i][1] +
        this.model.getEnvelopePriceForSelectedQuantityAndColorId(
          quantities[i][0]);
      if (price % 1) {
        return true;
      }
    }
    return false;
  },

  /**
   * If unitName is defined, returns a pluralised string of the
   * unitName value if the quantity is > 1. Returns unitName otherwise.
   */
  getUnitNameValue: function(quantity) {
    if (this.options.unitName) {
      return ' ' + plural(quantity, this.options.unitName,
          this.options.unitName + 's');
    }
    return '';
  },

  /**
   * Renders the HTML for the quantity picker with the pricing of the currently
   * selected product options.
   */
  render: function() {
    this.$el.empty();

    var quantityPriceDict = this.model.getQuantityPriceDiffDict();
    var quantities = M.Dict.sortByKeys(quantityPriceDict);

    // Special case for accessories, add an option with the text 'None' to allow
    // the user to select 0 for an accessory.
    if (this.model.isAccessory()) {
      var noneOption = $('<option>')
        .attr('value', 0)
        .text('Add');
      this.$el.append(noneOption);
    }

    var containsDecimals = this.priceListContainsDecimals(quantities);

    for (var i = 0, len = quantities.length; i < len; i++) {
      var price = quantities[i][1] +
        this.model.getEnvelopePriceForSelectedQuantityAndColorId(
          quantities[i][0]);
      // If the price is not an integer, fix the number of decimal values.
      // If there are prices in the price list that contains fixed decimal
      // values, we  want to fix all prices with a fixed decimal value
      if (price % 1 || containsDecimals) {
        price = price.toFixed(2);
      }
      var option = $('<option>')
        .attr('value', quantities[i][0])
        .text(quantities[i][0] + this.getUnitNameValue(quantities[i][0]) +' @ $' + price);
      this.$el.append(option);
    }

    this.$el.val(this.model.get('quantity'));
    return this;
  },

  /**
   * Track quantity change event
   */
  trackQuantityChange: function(oldQuantity, newQuantity, sku) {
    M.sendTrackAPI({
      'feature': M.GA.TRACK_EVENT_CATEGORY.PDP,
      'event': M.GA.TRACK_EVENT_ACTION.CHANGE_QUANTITY,
      'sku': sku,
      'old_quantity': oldQuantity,
      'new_quantity': newQuantity
    });
  },

  /**
   * Triggers a 'quantitySelected' event when the quantity is changed.
   */
  onChange: function() {
    var oldQuantity = this.model.get('quantity');
    var newQuantity = parseInt(this.$el.val(), 10);
    this.trackQuantityChange(
      oldQuantity, newQuantity, this.model.get('productSku'));
    this.trigger('quantitySelected', newQuantity);
  }
});
